import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';

import { request as saveParticipant } from '../../../modules/participants/actions/create';
import { request as updateParticipant } from '../../../modules/participants/actions/update-participant';
import { request as onSearchParticipants } from '../../../modules/participants/actions/query';

import { List } from 'immutable';

import Participants from './Participants.jsx';

function mapStateToProps( state, props ) {
    const { sportId } = props;
    const participants = state.participants.getIn( [ 'collections', sportId, 'items' ], List() );

    return {
        participants
    };
}

function mapDispatchToProps( dispatch, props ) {
    const { sportId } = props;

    return {
        saveParticipant: participant => dispatch( saveParticipant( participant ) ),
        updateParticipant: participant => dispatch( updateParticipant( sportId, participant ) ),
        searchParticipant: criteria => dispatch( onSearchParticipants(
            sportId,
            Object.assign( {}, criteria, { sport: sportId } )
        ) )
    };
}

export default decorate(
    connect( mapStateToProps, mapDispatchToProps ),
    Participants
);
